import React, { useContext } from 'react'
import { Row, Col } from 'reactstrap'

import DocumentRejectionNotificationSettings from './notification_settings/rejection';

import DocumentFormContext from './context/document_form_context';

const DocumentNotificationSettings = props => {
  const {
    resource,
    callbacks: {
      setResource: onSetResource
    }
  } = props

  const {
    currentCustomer: {
      settings: {
        document: {
          enable_notification_settings: documentEnableNotificationSettings = false
        } = {}
      } = {}
    } = {}
  } = useContext(DocumentFormContext);

  return (
    documentEnableNotificationSettings ? (
      <Row>
        <Col>
          <DocumentRejectionNotificationSettings
            resource={resource}
            callbacks={{
              setResource: onSetResource
            }}
          />
        </Col>
      </Row>
    ) : null
  )
}

export default DocumentNotificationSettings
